import { useDeviceType } from '../../hooks';
/**
 * Компонента которая рендерит children только на выбранных типах устройства
 */
export const Responsive = function Responsive(_ref) {
  let {
    phone,
    tablet,
    desktop,
    children
  } = _ref;
  const deviceType = useDeviceType();
  const shouldRender = phone && deviceType === 'phone' || tablet && deviceType === 'tablet' || desktop && deviceType === 'desktop';
  if (shouldRender) {
    return children;
  }
  return null;
};